exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".period-media .media .preview {\n  width: 30%;\n  height: auto;\n  display: block;\n  overflow: auto; }\n\n.notesCss {\n  padding: 10px;\n  font-family: initial; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /vercel/path0/src/app/main/content/apps/e-commerce/solutionForm/spekwo-type/preview-image/preview-image.component.scss
// module id = ../../../../../src/app/main/content/apps/e-commerce/solutionForm/spekwo-type/preview-image/preview-image.component.scss
// module chunks = main